import './App.css';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/Global';
import React, { Suspense, useState, useEffect, useRef, useMemo } from 'react';
import EnvironmentBanner from "./components/EnvironmentBanner";
import { connect } from 'react-redux';
import * as actions from './store/actions/index';
import theme from './styles/theme';
import OwnerRoot from './containers/AccesRoots/OwnerRoot/OwnerRoot';
import LocataireRoot from './containers/AccesRoots/LocataireRoot/LocataireRoot';
import ClientRoot from './containers/AccesRoots/ClientRoot/ClientRoot';
import { useAuthUser } from "./api/auth";
import { Routes, Route } from "react-router";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { AbilityContext } from './ability/AbilityContext';
import { defineUserAbilities } from './ability/ability';

function App({ userData, userType }) {

    const { connectedUserId, isLoggedIn, username, logoutUrl, isLoading, access_data_key, bailleur_id, enquete_id, rolesOfUser } = useAuthUser();
    const navigate = useNavigate()
    const linkRef = useRef();
    const location = useLocation();
  
    useEffect(() => {
        if (!username && !isLoading) {
            linkRef?.current.click();
        } 
    }, [isLoading, username]);


    let routes;
    if (username) {
        switch (userType) {
            case "LOCATAIRE":
                routes = (
                    <LocataireRoot />
                )

                break;
            case "BAILLEUR":
                routes = (
                    <ClientRoot roles={rolesOfUser} BailleurId={bailleur_id} />
                )
                break;
            case "ADMIN_YOUNOV":
                routes = (
                    <OwnerRoot roles={rolesOfUser} userType={userType} />
                )
                break;

            default:
                routes = (
                    <OwnerRoot roles={rolesOfUser} userType={userType} />
                )
                break;
        }
    }

    const ability = useMemo(() => defineUserAbilities(rolesOfUser, connectedUserId, userData), [rolesOfUser, access_data_key]);

    return (
        <AbilityContext.Provider value={ability}>
            <EnvironmentBanner />
            <ThemeProvider theme={theme}>
                <GlobalStyles />

                {isLoading ? (

                    <Suspense fallback={(<div>loading ...</div>)}> </Suspense>

                ) :

                    !isLoggedIn ? (
                        //import.meta.env.MODE != 'development'?
                        //    <a href={localStorage.getItem("ParenteReferrer").split("-")[0] + "-" + import.meta.env.VITE_WEB_APP_SUFFIX_URL +import.meta.env.VITE_API_LOGIN_URL} ref={linkRef} style={{ display: "none" }}>Hidden login</a>
                        //:
                        <a href={import.meta.env.VITE_API_LOGIN_URL} ref={linkRef} style={{ display: "none" }}>Hidden login</a>

                    ) :

                        <div className="app">
                            {routes}
                        </div>
                }
            </ThemeProvider>
        </AbilityContext.Provider>
    );
}

const mapStateToProps = (state) => ({
   
    userData: state.users.userData,
    userType: state.auth.userType,
    
})
const mapDispatchToProps = dispatch => ({
   
})
export default connect(mapStateToProps, mapDispatchToProps)(App) 
